export enum EmployerSource {
  SELF_SERVICE = "SELF_SERVICE"
}
